export default __webpack_public_path__ + "assets/fondoBlancoMed.png";